import MMAMembership from "../board-memberships/MMAMemberhsip";

export default function MMADetails() {
  return (
    <div>
      <div className="mma-bg bg-image">
        <div className="gap-spacer"></div>
        <div className="page-title top-cap-outlines">
          <h2>Morrisville Municipal Authority (MMA)</h2>
        </div>

        {/*End Large Image Space*/}

        {/*Start Main Content*/}
        <div className="content-fluid">
          <div className="mb-960-center-container mid-side-outlines">
            {/*Full Width Element*/}
            <div className="mb-960-col-50p left-side-col-50p">
              <h4>Meetings</h4>
              <ul>
                <li>7:00 p.m.</li>
                <li>3rd Thursday of the month</li>
                <li>
                  <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                    <i className="fa-solid fa-location-pin"></i>&nbsp;Borough Hall
                    <br />
                    35 Union Street
                    <br />
                    Morrisville, PA 19067
                  </a>
                  <br />
                </li>
              </ul>
              <h4>Composition</h4>
                <ul>
                  <li>5 Members</li>
                  <li>5 year terms</li>
                  <li>Terms expire on the first Monday in January</li>
                </ul>    
              {/*Accordion Start*/}
              <div className="container accordion-container">
                <div className="accordion" id="MMAAccordion">
                  {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMMAwebsite">
                        <div>
                          <i className="fa-solid fa-globe fa-2xl feature-icon af-icon"></i>
                        </div>

                        <div>
                          <b>MMA Website</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseMMAwebsite" className="accordion-collapse collapse" data-bs-parent="MMAAccordion">
                      <div className="accordion-body">
                        All Morrisville Municipal Authority information can be found on their website:{" "}
                        <a href="http://www.mmawatersewer.org/">
                          http://www.mmawatersewer.org/&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                  {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseMMApurpose">
                        <div>
                          <i className="fa-solid fa-scroll fa-2xl feature-icon af-icon"></i>
                        </div>
                        <div>
                          <b>Purpose</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseMMApurpose" className="accordion-collapse collapse" data-bs-parent="MMAAccordion">
                      <div className="accordion-body">
                        <p>
                          The Morrisville Municipal Authority (MMA) operates under the “Municipality Authorities Act,” a Pennsylvania law authorizing the creation of separate legal entities, known as
                          “Authorities” for the purpose of financing and operating a wide range of public works projects. The MMA, created in 1948 by the Borough of Morrisville, owns and operates the
                          water and wastewater (sewer) treatment plants and systems.
                        </p>
                        <p>
                          The MMA is managed by a Board of Directors, consisting of five (5) people appointed by Borough Council, serving staggered terms and exercising autonomous oversight of MMA
                          business and operations. Directors must be Morrisville residents, Morrisville taxpayers, Morrisville business owners or managers, or citizens of a municipality that the MMA
                          serves.
                        </p>

                        <p>
                          The Board typically reorganizes in January of each year, appointing a Chair; Vice-Chair; Secretary; Treasurer; and, Assistant Secretary-Treasurer. Meetings are conducted on
                          the third Thursday of every month, except August. An agenda is post online and outside the meeting room at the beginning of meeting weeks, identifying items coming before the
                          Board and any motions or resolutions which might be considered.
                        </p>

                        <p>
                          As part of its annual financial responsibility to the public, the Board reviews the proposed budget for the following year, usually in October and reviews the annual
                          certified audit for the previous year, usually in June or July.{" "}
                        </p>

                        <p>
                          The MMA Directors, administration, managers, and employees are responsible for safeguarding the health and welfare of their customers, who rely upon them for delivery of
                          clean drinking water and the collection, treatment, and disposal of wastewater/sewage. Terms are five (5) years expiring on the first (1st) Monday in January.
                        </p>
                      </div>
                    </div>

                    
                    
                  </div>
                  {/* Item Finish */}
                    {/* Item Start */}
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <button className="accordion-button caret-off collapsed darkblue-item button-full-width" type="button" data-bs-toggle="collapse" data-bs-target="#collapseBoardApply">
                        <div>
                          <i className="fa-solid fa-person-circle-plus fa-2xl feature-icon af-icon"></i>
                        </div>

                        <div>
                          <b>Apply To Join The Board</b>
                        </div>
                      </button>
                    </h2>
                    <div id="collapseBoardApply" className="accordion-collapse collapse" >
                      <div className="accordion-body">
                        Please send letters of interest to:<br/> <a href="mailto:office@morrisvilleboro.org">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;office@morrisvilleboro.org
                  </a>
                      </div>
                    </div>
                  </div>
                  {/* Item Finish */}
                </div>
              </div>
              {/*Addordion Finish*/}
            </div>

            <div className="mb-960-col-50p">
              <div className="council-members">
               <MMAMembership/>
              </div>
            </div>
          </div>

          <div className="page-footer bottom-cap-outlines">&nbsp;</div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
          <div className="gap-spacer"></div>
        </div>
      </div>
    </div>
  );
}
